import { DialogComponent } from '@theme/dialog';

/**
 * MOXIE: guía de tallas PDP — DialogComponent + toggle CM/IN (mismo contrato que quick-view).
 * @extends DialogComponent
 */
export class PdpSizeGuideDialog extends DialogComponent {
  /**
   * @param {PointerEvent} event
   */
  setUnit(event) {
    const target = /** @type {HTMLButtonElement | null} */ (event.target);
    const unit = target?.dataset.unit;
    if (!unit) return;

    const { unitToggle } = this.refs;
    if (!unitToggle) return;

    unitToggle.dataset.activeUnit = unit;

    for (const button of unitToggle.querySelectorAll('.mox-pdp-size-guide__unit')) {
      button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
    }

    for (const cell of this.querySelectorAll('.mox-pdp-size-guide__table td[data-cm]')) {
      const value = unit === 'in' ? cell.dataset.in : cell.dataset.cm;
      if (value) cell.textContent = value;
    }
  }
}

if (!customElements.get('custom-pdp-size-guide')) {
  customElements.define('custom-pdp-size-guide', PdpSizeGuideDialog);
}
